/**
 * TreasuryPage — layout wrapper para las rutas /treasury/*
 * Provee el contenedor, encabezado dinámico y panel de ayuda según la sub-ruta activa.
 */
import { Outlet, useLocation } from 'react-router-dom'
import { PageHeader } from '@/components/HelpPanel'
import { HELP } from '@/data/helpContent'

const PAGE_META: Record<string, { title: string; subtitle: string; helpKey: string }> = {
  entities:   { title: 'Entidades de Factoring', subtitle: 'Bancos y entidades financieras para operaciones de factoring', helpKey: 'treasury.entities' },
  operations: { title: 'Operaciones de Factoring', subtitle: 'Cesiones de facturas y operaciones de factoring', helpKey: 'treasury.operations' },
  reports:    { title: 'Reportes de Tesorería', subtitle: 'Resumen de operaciones, montos cedidos y pagos recibidos', helpKey: 'treasury.reports' },
  'foreign-debts': { title: 'Deudas con el Exterior', subtitle: 'Catálogo de obligaciones financieras con acreedores extranjeros para la Declaración Jurada N°1930', helpKey: '' },
  'dj-1930':       { title: 'DJ 1930 — Endeudamiento con el Exterior', subtitle: 'Obligaciones financieras con acreedores extranjeros vigentes al cierre del año comercial', helpKey: '' },
}

export function TreasuryPage() {
  const { pathname } = useLocation()
  const segment = pathname.split('/').pop() || 'operations'
  const meta = PAGE_META[segment] || { title: 'Tesorería', subtitle: 'Gestión de operaciones de factoring', helpKey: '' }

  return (
    <div className="p-4 sm:p-6 max-w-7xl mx-auto">
      <PageHeader title={meta.title} subtitle={meta.subtitle} help={HELP[meta.helpKey]} />
      <Outlet />
    </div>
  )
}
